<template>
  <div class="bg-gray">
    <div class="form-content">
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
        v-if="!showInfo"
    >
      <van-cell-group>

        <van-field
            readonly
            clickable
            name="area"
            :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
            input-align="right"
            label="地区选择"
            placeholder="点击选择省市区"
            @click="showArea = true"
        />
        <van-popup v-model="showArea" position="bottom">
          <van-area
              :area-list="areaList"
              :value="formData.area"
              @confirm="onAreaConfirm"
              @cancel="showArea = false"
          />
        </van-popup>

        <van-field
            v-model="formData.danwei"
            :rules="[{ required: true, message: '不能为空' }]"
            label="俱乐部名称"
            input-align="right"
            error-message-align="right"
            clearable
            placeholder="请输入俱乐部名称"
        />
        <!--            <van-field name="radio" label="类型"-->
        <!--                       input-align="right">-->
        <!--                <template #input>-->
        <!--                    <van-radio-group v-model="formData.clubleixing" direction="horizontal">-->
        <!--                        <van-radio checked-color="#ffb01b" name="社会俱乐部">社会俱乐部</van-radio>-->
        <!--                        <van-radio checked-color="#ffb01b" name="学校俱乐部">学校俱乐部</van-radio>-->
        <!--                    </van-radio-group>-->
        <!--                </template>-->
        <!--            </van-field>-->
        <van-field name="radio" label="申报等级"
                   input-align="right">
          <template #input>
            <van-radio-group v-model="formData.bgrade">
              <!--                        <van-radio checked-color="#ffb01b" name="一星">一星</van-radio>-->
              <van-radio checked-color="#ffb01b" name="二星">二星</van-radio>
              <van-radio checked-color="#ffb01b" name="三星">三星</van-radio>
              <van-radio checked-color="#ffb01b" name="四星">四星</van-radio>
              <van-radio checked-color="#ffb01b" name="五星">五星</van-radio>
            </van-radio-group>
          </template>
        </van-field>

      </van-cell-group>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交申请
        </van-button>
      </div>
    </van-form>


    <div v-else>
      <div style="padding: 0 .2rem">
        <ul class="step-two-box">
          <li>提交申报信息成功！</li>
          <li>工作人员会在三个工作日内与您联系。</li>
          <li>审批通过后，点击 “刷新”按钮，方可</li>
          <li>进行下一步操作</li>
        </ul>
      </div>

      <div class="savebtn">
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round >
          刷新
        </van-button>
      </div>
    </div>
  </div>
  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}
step-two-box {
  padding: .4rem .2rem;
  font-size: 16px;
}

.step-two-box li {
  margin-bottom: .3rem;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'ClubApply',
  components: {
    PicUploader,
  },
  data: function () {
    return {
      validator,
      saveLoading: false,
      showArea: false,
      showInfo: false,
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsqq: '',
        qq: '',
        city: '',
        county: '',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        changdipic: [],
        shenbaozip: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
        zhizhaopic: [],
      },
    }
  },
  filters: {},
  mounted() {
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    document.title = "升级星级俱乐部"
//            if(that.formData.id){
    this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;


      // return
      for (let field in that.formData) {

        // if (that.formData.changdipic.length != 5) {
        //     Toast('请上传5张场地照片');
        //     return
        // }
        if (that.formData.shenbaozip.length == 0) {
          // Toast('请上传申报表');
          // return
        }
        if (!that.formData.bgrade || that.formData.bgrade == '一星') {
          Toast('请选择等级');
          return
        }
        // if (!that.formData.clubleixing ) {
        //     Toast('请选择俱乐部类型');
        //     return
        // }
        // if (!this.formData.area) {
        //     Toast('请选择地区');
        //     return
        // }
      }
      that.saveLoading = true;


      that.$api.post('/api/club/gradeApply', that.formData, (res) => {
        that.saveLoading = false;
       that.showInfo = true
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
    },
    fetch() {
      let that = this;
      that.$api.post('/api/club/gradeApplyDetail', {
        id: that.formData.id
      }, (res) => {
        that.formData = res.data;
        if (res.data.kaojiregist_status == 1 || res.data.kaojiregist_status == 2) {
          rbLink({
            name: "ClubResult",
            query: {
              id: res.data.id
            }
          }, 'replace')
        }
      }, (res) => {
//                    Toast.fail(res.msg);
      })
    }

  }
}
</script>



// WEBPACK FOOTER //
// ClubHighApply.vue?77b3f56d